module.exports = __webpack_public_path__ + "img/iconProjectProductPort.58482b0c.svg";